export default {"src":"/expo/_next/static/media/box.d67ee6b2.svg","height":383,"width":711,"blurWidth":0,"blurHeight":0};